import React, { useEffect, useState } from "react";
import TextBox from "devextreme-react/text-box";
import CheckBox from "devextreme-react/check-box";
import LVButtonAccion from "../../../Basicos/LVButtonAccion";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { validarEMail } from "../../../../funciones/Varios";
import LV_GEO from "./LV_GEO";
import ComboAbmEexLocacionesTipos from "../../Combos/ComboAbmEexLocacionesTipos";
import ComboAbmTraEmpresasTransporte from "../../Combos/ComboAbmTraEmpresasTransporte";
import ComboAbmTraEmpresasTransporteLocaciones from "../../Combos/ComboAbmTraEmpresasTransporteLocaciones";

const LV_EEX_Locaciones = ({ index, datos, setDatos,
    generarJson, insertar, modificar, idCampo, campoCodigoLocacion }) => {
    const [errores, setErrores] = useState({});
    const locacion = datos.Locaciones?.[index];
    const [mapCenter, setMapCenter] = useState({ lat: -34.6037, lng: -58.3816 });
    const [descPais, setDescPais] = useState("");
    const [descCiudad, setDescCiudad] = useState("");
    const [reloadLocacionesEmpresasTransporte, setReloadLocacionesEmpresasTransporte] = useState(false);

    const handleOnValueChanged = (campo, valor) => {
        const nuevasLocaciones = [...datos.Locaciones];
        nuevasLocaciones[index] = {
            ...nuevasLocaciones[index],
            [campo]: valor
        };
        setDatos((prev) => ({
            ...prev,
            Locaciones: nuevasLocaciones
        }));
    };

    useEffect(() => {
        if (locacion && locacion.Coordenadas) {
            const [lat, lng] = locacion.Coordenadas.split(",").map(parseFloat);
            setMapCenter({ lat, lng });
        }
    }, [locacion.Coordenadas]);

    useEffect(() => {
        setReloadLocacionesEmpresasTransporte(true)
    }, [locacion.CodigoEmpresaTransporte]);

    const geolocalizar = async () => {
        if (!validar()) return;
        const direccion = `${locacion.Calle || ""} ${locacion.Numero || ""}, ${descCiudad}, ${descPais}`;
        const apiKey = "AIzaSyBonOpTS8899vfce_kjSlCwIjFH4gl68Vg";
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
            direccion
        )}&key=${apiKey}`;

        try {
            const resp = await fetch(url);
            const data = await resp.json();
            const location = data.results[0]?.geometry?.location;
            if (location) {
                const coords = `${location.lat},${location.lng}`;
                handleOnValueChanged("Coordenadas", coords);
                locacion.Coordenadas = coords
                handleOnClick_Guardar()
                setMapCenter(location);
            } else {
                alert("No se pudo ubicar la dirección.");
            }
        } catch (error) {
            alert("Error al buscar la dirección: " + error.message);
        }
    };

    const validar = () => {
        const nuevosErrores = {};
        if (!locacion[campoCodigoLocacion]) nuevosErrores[campoCodigoLocacion] = "Campo requerido";
        if (!locacion.IdTipoLocacion) nuevosErrores.IdTipoLocacion = "Campo requerido";
        if (!locacion.Email) {

        } else if (!validarEMail(locacion.Email)) {
            nuevosErrores.Email = "Email inválido";
        }
        return nuevosErrores;
    };

    const handleOnClick_Guardar = async () => {
        if (!validar()) return;

        const json = await generarJson(
            datos[idCampo],
            locacion[campoCodigoLocacion],
            locacion.IdTipoLocacion,
            locacion.Calle,
            locacion.Numero,
            locacion.Piso,
            locacion.Depto,
            locacion.CodigoPostal,
            locacion.IdPais || null,
            locacion.Email,
            locacion.Telefono,
            locacion.TelefonoFax,
            locacion.TelefonoCelular,
            locacion.HorarioAtencion,
            locacion.Responsable1,
            locacion.Responsable2,
            locacion.Responsable3,
            locacion.Observaciones,
            locacion.EsDefaultParaRemito,
            locacion.IdCiudad || null,
            locacion.DomicilioFacturacion,
            locacion.CodigoEmpresaTransporte,
            locacion.CodigoLocacionEmpresaTransporte,
            locacion.CodigoZona,
            locacion.Coordenadas
        );

        try {
            if (locacion[idCampo]) {
                await modificar(json);
                alert("Locación modificada con éxito");
            } else {
                await insertar(json);
                alert("Locación guardada con éxito");
            }
        } catch (error) {
            alert("Error al guardar locación: " + error.message);
        }
    };

    const renderGrupo = (titulo, campos) => (
        <fieldset style={{ border: "1px solid #ccc", padding: "10px", marginTop: "10px" }}>
            <legend style={{ padding: "0 10px" }}>{titulo}</legend>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
                {campos}
            </div>
        </fieldset>
    );

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

            {/* Básicos */}
            {renderGrupo("Básicos", [
                <TextBox value={locacion[campoCodigoLocacion]} placeholder="Código Locación" width={160} isValid={!errores[campoCodigoLocacion]} validationMessage={errores[campoCodigoLocacion]} onValueChanged={e => handleOnValueChanged(campoCodigoLocacion, e.value)} />,
                <ComboAbmEexLocacionesTipos
                    CodigoCompania={localStorage.getItem("CodigoCompania")}
                    CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                    CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                    value={locacion.IdTipoLocacion}
                    ancho={300}
                    onValueChanged={(e) => handleOnValueChanged("IdTipoLocacion", e.value)} />,
                <TextBox value={locacion.Observaciones} placeholder="Observaciones" width={300} onValueChanged={e => handleOnValueChanged("Observaciones", e.value)} />,
                <CheckBox text="Default para Remito" value={locacion.EsDefaultParaRemito} onValueChanged={e => handleOnValueChanged("EsDefaultParaRemito", e.value)} />,
                <CheckBox text="Domicilio Facturación" value={locacion.DomicilioFacturacion} onValueChanged={e => handleOnValueChanged("DomicilioFacturacion", e.value)} />,
            ])}

            {/* Dirección y Mapa lado a lado */}
            <div style={{ display: "flex", gap: "20px", alignItems: "flex-start" }}>
                <div style={{ flex: 1 }}>
                    {renderGrupo("Dirección", [
                        <TextBox value={locacion.Calle} placeholder="Calle" width={160} onValueChanged={e => handleOnValueChanged("Calle", e.value)} />,
                        <TextBox value={locacion.Numero} placeholder="Número" width={100} onValueChanged={e => handleOnValueChanged("Numero", e.value)} />,
                        <TextBox value={locacion.Piso} placeholder="Piso" width={80} onValueChanged={e => handleOnValueChanged("Piso", e.value)} />,
                        <TextBox value={locacion.Depto} placeholder="Depto" width={80} onValueChanged={e => handleOnValueChanged("Depto", e.value)} />,
                        <TextBox value={locacion.CodigoPostal} placeholder="Código Postal" width={120} onValueChanged={e => handleOnValueChanged("CodigoPostal", e.value)} />,
                        <LV_GEO
                            Ancho={330}
                            IdPais={locacion.IdPais}
                            IdProvinciaEstado={locacion.IdProvinciaEstado}
                            IdCiudad={locacion.IdCiudad}
                            onChangePais={(val) => handleOnValueChanged("IdPais", val)}
                            onChangeProvincia={(val) => handleOnValueChanged("IdProvinciaEstado", val)}
                            onChangeCiudad={(val) => handleOnValueChanged("IdCiudad", val)}
                            onChangePaisDescripcion={(txt) => setDescPais(txt)}
                            onChangeCiudadDescripcion={(txt) => setDescCiudad(txt)}
                        />,
                        <TextBox value={locacion.Coordenadas} placeholder="Coordenadas" width={160} onValueChanged={e => handleOnValueChanged("Coordenadas", e.value)} />,
                        <LVButtonAccion Texto={"UBICAR EN MAPA"} onClick={() => geolocalizar()} />,
                        <TextBox value={locacion.CodigoZona} placeholder="Zona" width={120} onValueChanged={e => handleOnValueChanged("CodigoZona", e.value)} />
                    ])}

                    {/* Contacto */}
                    {renderGrupo("Contacto", [
                        <TextBox value={locacion.Email} placeholder="E-Mail" width={200} onValueChanged={e => handleOnValueChanged("Email", e.value)} />,
                        <TextBox value={locacion.Telefono} placeholder="Teléfono" width={160} onValueChanged={e => handleOnValueChanged("Telefono", e.value)} />,
                        <TextBox value={locacion.TelefonoFax} placeholder="Fax" width={160} onValueChanged={e => handleOnValueChanged("TelefonoFax", e.value)} />,
                        <TextBox value={locacion.TelefonoCelular} placeholder="Celular" width={160} onValueChanged={e => handleOnValueChanged("TelefonoCelular", e.value)} />,
                    ])}

                    {/* Responsables */}
                    {renderGrupo("Responsables", [
                        <TextBox value={locacion.HorarioAtencion} placeholder="Horario Atención" width={200} onValueChanged={e => handleOnValueChanged("HorarioAtencion", e.value)} />,
                        <TextBox value={locacion.Responsable1} placeholder="Responsable 1" width={180} onValueChanged={e => handleOnValueChanged("Responsable1", e.value)} />,
                        <TextBox value={locacion.Responsable2} placeholder="Responsable 2" width={180} onValueChanged={e => handleOnValueChanged("Responsable2", e.value)} />,
                        <TextBox value={locacion.Responsable3} placeholder="Responsable 3" width={180} onValueChanged={e => handleOnValueChanged("Responsable3", e.value)} />,
                    ])}
                </div>

                <div style={{ width: "700px", height: "443px", zIndex: 1 }}>
                    <LoadScript googleMapsApiKey="AIzaSyBonOpTS8899vfce_kjSlCwIjFH4gl68Vg">
                        <GoogleMap
                            mapContainerStyle={{ width: "100%", height: "100%" }}
                            center={mapCenter}
                            zoom={15}
                        >
                            {locacion.Coordenadas && (
                                <Marker
                                    key={locacion.Coordenadas}
                                    position={{
                                        lat: parseFloat(locacion.Coordenadas.split(",")[0]),
                                        lng: parseFloat(locacion.Coordenadas.split(",")[1])
                                    }}
                                    draggable={true}
                                    title="Ubicación seleccionada"
                                    icon={{
                                        url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png"
                                    }}
                                    onDragEnd={(e) => {
                                        const lat = e.latLng.lat();
                                        const lng = e.latLng.lng();
                                        const nuevaCoordenada = `${lat},${lng}`;
                                        handleOnValueChanged("Coordenadas", nuevaCoordenada);
                                        locacion.Coordenadas = nuevaCoordenada;
                                        setMapCenter({ lat, lng });
                                    }}
                                />
                            )}
                        </GoogleMap>
                    </LoadScript>
                </div>
            </div>

            {/* Transporte */}
            {renderGrupo("Transporte", [
                <ComboAbmTraEmpresasTransporte
                    value={locacion.CodigoEmpresaTransporte}
                    onValueChanged={e => handleOnValueChanged("CodigoEmpresaTransporte", e.value)}
                    ancho="300"
                />,
                <ComboAbmTraEmpresasTransporteLocaciones
                    value={locacion.CodigoLocacionEmpresaTransporte}
                    onValueChanged={e => handleOnValueChanged("CodigoLocacionEmpresaTransporte", e.value)}
                    CodigoEmpresaTransporte={locacion.CodigoEmpresaTransporte}
                    reloadData={reloadLocacionesEmpresasTransporte}
                    ancho="300"
                />
            ])}

            <div style={{ marginTop: "10px" }}>
                <LVButtonAccion Texto={locacion[idCampo] ? "MODIFICAR" : "GUARDAR"} onClick={() => handleOnClick_Guardar()} />
            </div>
        </div>
    );
};

export default LV_EEX_Locaciones;